import React from 'react';

import { LoadingStatus } from './hooks';

export type LoadingDoneVariant = 'success' | 'warning' | 'error';
export interface LoadingContextValues {
  isLoading: boolean;
  statuses: LoadingStatus[];
}

export interface LoadingContextState extends LoadingContextValues {
  startLoading: (name: string) => void;
  doneLoading: (name: string, state?: LoadingDoneVariant, message?: string) => void;
  shiftStatus: () => void;
}

export const LoadingContext = React.createContext<LoadingContextState>({
  isLoading: false,
  statuses: [],
  startLoading: (name: string) => console.error(`LoadingContext not found: ${name}`),
  doneLoading: (name: string, _state?: LoadingDoneVariant, _message?: string) =>
    console.error(`LoadingContext not found: ${name}`),
  shiftStatus: () => console.error('LoadingContext not found'),
});
